// School, TrueChops's official extension for classrooms. It's built like any other plugin (see
// /platform): its pages, its place in the menu and its button on the Score all come through the
// platform's api, and its server half is ./server.js.
import dynamic from "next/dynamic";
import { createElement as h } from "react";

const Home = dynamic(() => import("./SchoolHome"), { ssr: false });
const ClassPage = dynamic(() => import("./ClassPage"), { ssr: false });
const Editor = dynamic(() => import("./AssignmentEditor"), { ssr: false });
const Assignment = dynamic(() => import("./AssignmentPage"), { ssr: false });
const Join = dynamic(() => import("./Join"), { ssr: false });
const AssignButton = dynamic(() => import("../../src/components/teaching/AssignButton"), { ssr: false });

const school = {
  id: "school",
  name: "School",
  official: true,
  setup(api) {
    api.page("/", Home, { title: "Classes" });
    api.page("/join/:code", Join, { title: "Join a class" });
    api.page("/c/:id", ClassPage, { title: "Class" });
    api.page("/c/:id/new", Editor, { title: "New assignment" });
    api.page("/a/:id", Assignment, { title: "Assignment" });
    api.page("/a/:id/edit", Editor, { title: "Edit assignment", props: { editing: true } });
    api.filter("nav.places", (places) => api.installed() ? places.map((place) => place.id === "play" ? { ...place, tabs: [...place.tabs, { id: "school", label: "Classes", href: "/school", app: "school" }] } : place) : places);
    api.slot("score.toolbar.end", () => api.installed() ? h(AssignButton, { to: "/school", label: "Assign" }) : null);
  },
};
export default school;
